import React, { Component } from "react";
import PropTypes from "prop-types";
import Select from "@material-ui/core/Select";
import { withStyles } from "@material-ui/core/styles";
import LinearProgress from "@material-ui/core/LinearProgress";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import http from "../../util/http";
import "react-dates/initialize";
import RecentMessageResult from "./RecentMessageResult";
import { MuiThemeProvider } from "@material-ui/core/styles";
import aceTheme from "../../util/aceTheme";
const styles = (theme) => ({
  container: {
    display: "flex",
    flexWrap: "wrap",
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 120,
  },
  progressLinear: {
    width: "100%",
    height: 5,
  },
});

const displayTop = [100, 50, 25, 10];
class RecentMessages extends Component {
  state = {
    top: 50,
    searching: true,
    recentMessages: [],
  };
  changeTop = (event) => {
    this.setState({ top: event.target.value });
  };
  recentMessagesInterval = async () => {
    try {
      // const activeUsers = await http.sendCommand("command:report:activeUsers
      this.setState({ searching: true });
      const recentMessages = await http.sendHelperCommand(
        "RecentMessagesHelper.aspx",
        { top: this.state.top }
      );
      this.setState({
        reasonVoid: "",
        searching: false,
        recentMessages,
      });
    } catch (err) {
      this.setState({
        reasonVoid: err.message,
        searching: true,
        recentMessages: [],
      });
    }
  };
  componentDidMount = async () => {
    setInterval(this.recentMessagesInterval, 5000);
  };
  render() {
    const { classes } = this.props;
    return (
      <MuiThemeProvider theme={aceTheme}>
        <div className={classes.container}>
          <form autoComplete="off">
            <FormControl className={classes.formControl}>
              <InputLabel htmlFor="top-messages">Display Last</InputLabel>
              <Select
                native
                value={this.state.top}
                onChange={this.changeTop}
                inputProps={{
                  id: "top-messages",
                }}
              >
                {displayTop.map((top) => (
                  <option value={top}>{top} Messages</option>
                ))}
              </Select>
            </FormControl>
          </form>
          {this.state.searching && (
            <LinearProgress className={classes.progressLinear} />
          )}
          <RecentMessageResult
            {...{
              recentMessages: this.state.recentMessages,
              reasonVoid: this.state.reasonVoid,
            }}
          />
        </div>
      </MuiThemeProvider>
    );
  }
}

RecentMessages.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(RecentMessages);
